module.exports = __webpack_public_path__ + "static/media/btn_primaryschool_07_TheNetizenPledge.c9c2d406.png";